import { datadogRum } from '@datadog/browser-rum';
import { User } from '@sentry/react';
import { baseConfig } from 'src/config';

export const setUserToDatadogRUM = (user: User) => {
  if (baseConfig.NODE_ENV !== 'production') return;

  datadogRum.setUser({
    id: user._id,
    name: user.name ?? `${user.firstName} ${user.lastName}`,
    email: user.email,
    isInternal: user.isSupportUser
  });
};

export const unsetUserDatadogRUM = () => {
  datadogRum.clearUser();
};
